import { useEffect } from 'react'

import useSaveChatThreadEvent from '~/App/ChatThreads/hooks/useSaveChatThreadEvent'

import { useSessionChatThreads } from '..'
import useSetChatThreadEvent from '../utils/useSetChatThreadEvent'

const useSaveSessionChatThreadEvent = () => {
  const state = useSaveChatThreadEvent()
  const { reload } = useSessionChatThreads()
  const setChatThreadEvent = useSetChatThreadEvent(reload)

  useEffect(() => {
    if (state.isSuccess) {
      setChatThreadEvent(state.data)
    }
  }, [state.isSuccess])

  return state
}

export default useSaveSessionChatThreadEvent
